import { shouldSignalBadgeActivity, BADGE_DISCOVERY_EVENTS } from './generated/activityRules';

const listeners = new Set();
let owner = null;
let revision = 0;
export function bindBadgeActor(userId) {
  owner = userId == null ? null : { userId, revision: ++revision };
  const bound = owner;
  return () => {
    if (owner === bound) owner = null;
  };
}
export const captureBadgeActor = () => owner && { ...owner };
export const isBadgeActorCurrent = (actor) =>
  !!actor && !!owner && actor.userId === owner.userId && actor.revision === owner.revision;
export function subscribeToBadgeActivity(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
export function isBadgeActivityRequest(config) {
  if (config?.requireAuth !== true) return false;
  const method = config.method?.toUpperCase(),
    path = config.url ?? '';
  if (shouldSignalBadgeActivity(path, method)) return true;
  if (
    method !== 'POST' ||
    !['/search/discovery/events', '/search/discovery/events/batch'].includes(path)
  )
    return false;
  try {
    const data = typeof config.data === 'string' ? JSON.parse(config.data) : config.data;
    const events = path.endsWith('/batch') ? data?.events : [data];
    return Array.isArray(events) && events.some((e) => BADGE_DISCOVERY_EVENTS.has(e?.eventType));
  } catch {
    return false;
  }
}
// The request captures the actor before transport. A late success cannot credit
// the next account, or even the same ID after a sign-out/sign-in cycle.
export function signalSuccessfulBadgeActivity(response) {
  const config = response?.config;
  if (
    !config?.signal?.aborted &&
    response?.status >= 200 &&
    response.status < 300 &&
    isBadgeActorCurrent(config.badgeActor) &&
    isBadgeActivityRequest(config)
  ) {
    listeners.forEach((listener) => {
      try {
        listener(config.badgeActor);
      } catch {
        /* Do not change the successful API result. */
      }
    });
  }
}
